export default "# Use Cases for Partial Common Ownership";